export const BOX_SCORES_WIDGET = {
  ACTION_TYPES: {
    allStatsToggle: 'allStatsToggle',
  },

  COMPETITORS: {
    home: 0,
    away: 1
  },

  TABLE_POSITION: {
    startPosition: 0
  },

  SPORT_TYPES_PLAYER_STATS_CARD_DISPLAY: {
    football: 1,
    basketball: 2
  },

  TABLE_SIZES: {
    rowPrimaryCellWidth: 132,
    rowPrimaryCellNoImageWidth: 90
  },

  ANALYTICS: {
    ACTION_TYPES: {
      toggleClick: 'toggleClick'
    }
  }
}
